










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import { currency } from '@filters/shared-filters';
import { getInvitationDetails } from '@api/referral';
import { HeaderStyle } from 'types/header';
import { InvestmentEntity } from 'types/investment-entity';
import { investmentEntity } from '@store/modules/investment-entity';
import { InvitationDetailsResponse } from 'types/referral';
import MobileNavTemplate from '@components/header/navigation/mobile/mobile-nav-template.vue';
import MobileNavUserHeader from './mobile-nav-user-header.vue';
import NavigationLinkMobile from '@components/header/navigation/mobile/navigation-link-mobile.vue';
import NavInvestmentEntityList from '../nav-investment-entity-list.vue';
import { user } from '@store/modules/user';

@Component({
	components: {
		MobileNavUserHeader,
		MobileNavTemplate,
		NavigationLinkMobile,
		NavInvestmentEntityList
	}
})
export default class MobileNavAuth extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	currency = currency;

	isInvestTabEnabled = false;
	referralAmount = '';

	get investmentEntityObject(): InvestmentEntity {
		return investmentEntity.investmentEntityObject;
	}

	get investTabEnabled(): boolean {
		return !this.investmentEntityObject.isIraEntity && this.isInvestTabEnabled;
	}

	get nav(): AuthenticatedNav {
		return new AuthenticatedNav(user.user, investmentEntity.investmentEntityObject);
	}

	async created(): Promise<void> {
		this.isInvestTabEnabled = await app.isFeatureEnabled('invest-tab');
		const invitationDetails: InvitationDetailsResponse = await getInvitationDetails();
		this.referralAmount = invitationDetails.invitationDetails.rewardPerInvite;
	}
}
